<script>
    import { api_host } from "../../stores.js";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { add_days_to_date, format_date_to_default_string } from "../../globals.js";
    import { querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import { push } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { formatDate } from "../../utils/format.js";


    const { auth_type, auth_token, domain_code } = getToken();

    let content_title = "Editing Coupon";
    let cid = "";
    let coupon = {};
    let is_busy = false;

    let fields = [
        {
            "index": 0,
            "group": "row1",
            "type": "text",
            "label": "Code",
            "value": "",
            "placeholder": "eg. MYCOOLCODE",
            "validation_function": () => {
                if (fields[0].value.length > 0) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Coupon Code is required';
                    return false;
                }
            },
        },
        {
            "index": 1,
            "group": "row1",
            "type": "text",
            "label": "Description",
            "value": "",
            "placeholder": "eg. Promo code to acquire new clients.",
        },
        {
            "index": 2,
            "group": "row2",
            "type": "select",
            "label": "Value Type",
            "value": "Maximum Amount $",
            "select_options": ["Maximum Amount $", "Percentage Discount %"],
            "helper_text": "Fixed value or percentage coupon."
        },
        {
            "index": 3,
            "group": "row2",
            "type": "text",
            "label": "Value",
            "value": "",
            "placeholder": "eg. $5.00 or 20.00%",
            "helper_text": "If type is fixed then any positive value. If type is percentage then any value 0-100",
            "validation_function": () => {
                if (fields[3].value > 0) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Value is required';
                    return false;
                }
            }
        },
        {
            "index": 4,
            "group": "row2",
            "type": "text",
            "label": "Redemption Limit",
            "value": "0",
            "hidden": true,
            "helper_text": "Number of times this coupon can be redeemed. 0 for unlimited. Only applies to percentage type."
        },
        {
            "index": 5,
            "group": "row3",
            "type": "date",
            "label": "Valid From",
            "value": format_date_to_default_string(new Date()),
            "change_function": (e) => {
                if (fields[7].value < e.target.value) {
                    fields[7].value = e.target.value;
                }
            },
        },
        {
            "index": 6,
            "group": "row3",
            "type": "select",
            "label": "Valid Timeframe",
            "value": "1 week",
            "select_options": ["1 week", "2 weeks", "3 weeks", "1 month", "3 months", "6 months"],
            "change_function": (e)=>{
                const time_frame = e.target.value;
                timeframeChange(time_frame, 5, 7);
            },
            "hidden": true,
        },
        {
            "index": 7,
            "group": "row3",
            "type": "date",
            "label": "Valid Until",
            "value": format_date_to_default_string(add_days_to_date(new Date(), 7)),
            "change_function": (e) => {
                if (fields[5].value > e.target.value) {
                    fields[7].value = fields[5].value;
                }
            },
            // "readonly": true,
        },
        {
            "index": 9,
            "group": "row4",
            "type": "textarea",
            "label": "Additional Comments",
            "value": "",
            "hidden": true,
            "maxlength": 1000,
            "placeholder": "... any additional comments for this gift card.",
        },
    ];

    onMount(async () => {
        const params = new URLSearchParams($querystring)

        if (params.has("cid")) {
            is_busy = true;
            cid = params.get("cid");
            const res = await doFetch(
                `${api_host}/api/coupon/get/${cid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                coupon = res.coupon;
                console.log(coupon);
                const { code, description, value_type, value, from_date, to_date } = coupon;
                fields[0].value = code;
                fields[1].value = description;
                fields[2].value = value_type;
                fields[3].value = value;
                fields[5].value = formatDate(from_date);
                fields[7].value = formatDate(to_date);
            }
            else { toast_message(false, res.msg || 'Fetching coupon failed', 3000); }
            is_busy = false;
        }
    });

    const timeframe_to_days_map = {
        "1 week": 7,
        "2 weeks": 7 * 2,
        "3 weeks": 7 * 3,
        "1 month": 7 * 4,
        "3 months": 7 * 4 * 3,
        "6 months": 7 * 4 * 6,
    };

    function timeframeChange(new_time_frame, start_date_object_index, end_date_object_index) {
        timeChange(new_time_frame, fields[start_date_object_index]["value"], end_date_object_index);
    }

    function timeChange(new_time_frame, start_date_string, end_date_object_index){
        const start_value = start_date_string;
        const day_range = timeframe_to_days_map[new_time_frame];
        var parts =start_value.split('/');
        var new_end_date = new Date(parseInt(parts[2]) + 2000, parts[0] - 1, parts[1]); 
        new_end_date.setDate(new_end_date.getDate() + day_range);
        setTimeout(() => {
            fields[end_date_object_index]["value"] = format_date_to_default_string(new_end_date);
        }, 250);
    }

    let validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (field.validation_function && !field.validation_function()) {
                is_valid = false;
            }
        });

        return is_valid;
    };
    
    let updateCoupon = async () => {
        if(validateForm()) {
            const payload = {
                'id': coupon.id,
                'code': fields[0].value,
                'description': fields[1].value,
                'value_type': fields[2].value === 'Maximum Amount $' ? 'Maximum Amount $' : 'Percentage Discount %',
                'value': fields[3].value,
                'from_date': fields[5].value,
                'to_date': fields[7].value,
                'valid_timeframe': fields[6].value
            };
            const res = await doFetch(
                `${api_host}/api/coupon/update`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 3000);
                push('#/Coupons');
            } else {
                toast_message(false, res.msg || 'Bad request', 3000);
            }
        } else {
            toast_message(false, 'Missing or invalid info', 3000);
        }
    };

</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section cardinfo">
        <div class="sectiontitle"><i class="fas fa-tag"></i> Coupon Information</div>

        <div class="sectioninfo">
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "row1") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:hidden={nf.hidden}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "row2") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:hidden={nf.hidden}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "row3") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:hidden={nf.hidden}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "row4") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    maxlength={nf.maxlength}
                    bind:hidden={nf.hidden}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>

        <div class="updatebutton">
            <button class="save" on:click={() => { updateCoupon(); }}>Save Changes</button>
        </div>
    </div>
</div>


<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
    .sectioninfo {
        width: 100%;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "cd cd cd cd cd cd cd cd cd cd cd cd"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .cardinfo {
        grid-area: ci;
    }
    .updatebutton {
        grid-area: ub;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        width: 200px;
        background-color: #357a38;
        color: white;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "ci"
                                 "cd"
                                 "ub";
            gap: 20px;

        }
        .cardinfo {
            grid-area: ci;
        }
        .updatebutton {
            grid-area: ub;
            display: flex;
            flex-direction: column;
            padding: 0px;
        }
        .updatebutton .save {
            width: 100%;
            background-color: #357a38;
            color: white;
        }
    }
</style>